document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header-wrapper');
    const mobileMenuToggles = document.querySelectorAll('.menu-toggle');
    const searchToggles = document.querySelectorAll('.search-toggle');

    console.log('Header script loaded', { header, headerWrapper });

    // Sticky header on scroll
    let ticking = false;
    
    function checkScroll() {
        if (!headerWrapper) {
            console.log('No headerWrapper found');
            return;
        }
        
        const scrollPos = Math.max(0, window.pageYOffset); // Prevent negative values on iOS
        
        if (scrollPos > 26) {
            if (!headerWrapper.classList.contains('fixed')) {
                const headerHeight = headerWrapper.offsetHeight;
                document.body.style.paddingTop = '67px';
                headerWrapper.classList.add('fixed');
                console.log('Added fixed class', scrollPos);
            }
        } else {
            if (headerWrapper.classList.contains('fixed')) {
                document.body.style.paddingTop = '';
                headerWrapper.classList.remove('fixed');
                console.log('Removed fixed class', scrollPos);
            }
        }
        
        ticking = false;
    }
    
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(checkScroll);
            ticking = true;
        }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    checkScroll(); // Check on load

    // Mobile menu toggle functionality
    if (mobileMenuToggles.length) {
        mobileMenuToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                document.body.classList.remove('search-open', 'need-help-open');
                document.body.classList.toggle('menu-open');
            });
        });
    }

    // Search toggle functionality
    if (searchToggles.length) {
        searchToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                document.body.classList.remove('menu-open', 'need-help-open');
                document.body.classList.toggle('search-open');
                
                // Focus the search input when opening
                if (document.body.classList.contains('search-open')) {
                    setTimeout(function() {
                        const searchInput = document.querySelector('.search-input, input[type="search"]');
                        if (searchInput) {
                            searchInput.focus();
                        }
                    }, 100);
                }
            });
        });
    }

    // Menu close functionality - closes both menu and search
    const menuCloseToggles = document.querySelectorAll('.menu-close');
    if (menuCloseToggles.length) {
        menuCloseToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                document.body.classList.remove('menu-open');
                document.body.classList.remove('search-open');
                document.body.classList.remove('need-help-open');
            });
        });
    }
});